// ListAction can be: "create" | "remove" | "split" | "merge" | "noop" | "revert" | "convertNested"

export const convertPNodeToLi = ({ blocks }) => {
  return blocks.map((block) => {
    // Nếu đã là li, return luôn
    if (block.tagName.toLowerCase() === "li") return block;

    const li = document.createElement("li");

    // Move children sang li
    while (block.firstChild) {
      li.appendChild(block.firstChild);
    }

    li.setAttribute("data-from-command", "true");

    // Remove block from DOM
    block.parentNode?.removeChild(block);

    return li;
  });
};

export const checkNodeIsOverList = ({ blocks }) => {
  return blocks.filter((b) => b.tagName.toLowerCase() === "li").length > 0;
};

export const getParentLi = (node) => {
  while (node) {
    if (node.tagName?.toLowerCase() === "li") return node;
    node = node.parentElement;
  }
  return null;
};

export const getParentList = (node) => {
  while (node) {
    const tag = node.tagName?.toLowerCase();
    if (tag === "ul" || tag === "ol") return node;
    node = node.parentElement;
  }
  return null;
};

export const isInsideList = (block) => {
  return !!getParentLi(block);
};

export const isInsideNestedList = (block) => {
  const parentLi = getParentLi(block);
  if (!parentLi) return false;

  const parentList = parentLi.parentElement;
  if (!parentList) return false;

  const tag = parentList.tagName.toLowerCase();
  if (tag !== "ul" && tag !== "ol") return false;

  // Check if parent list is inside another ul/ol
  const grandParent = parentList.parentElement;
  if (!grandParent) return false;

  const gpTag = grandParent.tagName.toLowerCase();
  return gpTag === "ul" || gpTag === "ol";
};

// Convert nested list: reduce level or change type
export const convertNestedList = ({ blocks, targetType }) => {
  // Process unique nested lists to avoid duplicate processing
  const processedLists = new Set();

  blocks.forEach((block) => {
    const parentLi = getParentLi(block);
    if (!parentLi) return;

    const parentList = parentLi.parentElement;
    if (!parentList) return;

    const currentType = parentList.tagName.toLowerCase();
    if (currentType !== "ul" && currentType !== "ol") return;

    const grandParent = parentList.parentElement;
    if (!grandParent) return;

    const gpTag = grandParent.tagName.toLowerCase();
    if (gpTag !== "ul" && gpTag !== "ol") return;

    // Avoid processing same list multiple times
    if (processedLists.has(parentList)) return;
    processedLists.add(parentList);

    // Case 1: Outer list matches target type → reduce 1 level (unwrap nested list)
    // Example: <ol><ol><li>...</li></ol></ol> + click ol → <ol><li>...</li></ol>
    if (gpTag === targetType) {
      // Get all li elements in nested list
      const lis = Array.from(parentList.children).filter(
        (child) => child.tagName.toLowerCase() === "li",
      );

      // Move each li from nested list to outer list
      lis.forEach((li) => {
        if (parentList.nextSibling) {
          grandParent.insertBefore(li, parentList.nextSibling);
        } else {
          grandParent.appendChild(li);
        }
      });

      // Remove empty nested list
      parentList.remove();
    }
    // Case 2: Outer list doesn't match target type → convert nested list type
    // Example: <ul><ol><li>...</li></ol></ul> + click ol → <ul><ul><li>...</li></ul></ul>
    else {
      const newList = document.createElement(targetType);

      // Move all children from old list to new list
      while (parentList.firstChild) {
        newList.appendChild(parentList.firstChild);
      }

      // Replace old list with new list
      parentList.parentNode?.replaceChild(newList, parentList);
    }
  });
};

export const getUniqueParentLists = (blocks) => {
  const lists = new Set();

  blocks.forEach((b) => {
    const list = getParentList(b);
    if (list) lists.add(list);
  });

  return Array.from(lists);
};

export const isFullListSelected = (list, blocks) => {
  const lis = Array.from(list.children).filter(
    (child) => child.tagName.toLowerCase() === "li",
  );

  const selectedLis = blocks.map(getParentLi).filter(Boolean);

  return lis.every((li) => selectedLis.includes(li));
};

export const detectListAction = ({ blocks }) => {
  if (!blocks.length) return "noop";

  const insideListFlags = blocks.map(isInsideList);
  const allInsideList = insideListFlags.every(Boolean);
  const noneInsideList = insideListFlags.every((v) => !v);

  // Check if any block is in nested list
  const hasNestedList = blocks.some(isInsideNestedList);

  const parentLists = getUniqueParentLists(blocks);

  // CASE 1 — Tất cả là paragraph → CREATE
  if (noneInsideList) return "create";

  // CASE 2 — Tất cả nằm trong list
  if (allInsideList) {
    // If in nested list, return convertNested action
    if (hasNestedList) return "convertNested";

    // chỉ 1 list duy nhất
    if (parentLists.length === 1) {
      const list = parentLists[0];

      // full list selected → REMOVE
      if (
        isFullListSelected(list, blocks) &&
        list.tagName.toLowerCase() === "ul"
      ) {
        return "remove";
      } else if (
        isFullListSelected(list, blocks) &&
        list.tagName.toLowerCase() !== "ul"
      )
        return "revert";
      // partial → SPLIT
      return "split";
    }

    // nhiều list → MERGE
    return "merge";
  }

  // CASE 3 — Mixed p + li → MERGE
  return "merge";
};
